import GET_ARTICLES from "../plugins/getArticles";
const [w,l] = [window,location]

const guidance_init = () => {
  GET_ARTICLES('.p-guidance-nav').done(() => {
    const url = l.search ? l.pathname+l.search : l.pathname+'?mode=detail&article=1'
    $('.p-guidance-nav').currentMenu({mode:0,default:999,url})
  })
}
export default function GUIDANCE () {
  w.addEventListener('DOMContentLoaded',guidance_init)
}